<template>
  <el-form class="common-dialog-form" ref="form" :model="form" :rules="dialogRules" size="medium" inline label-width="56px"
           :label-position="typeof dialogData.type === 'string'?'right':'top'"
           style="height: 100%;">
    <!-- item 属性: type-类型 支持   文本label
                                    输入框input
                                    选择器select
                                    切换switch
                                    多选-常规勾选形式checkboxGroup
                                    多选-按钮形式checkboxButtonGroup
                                    时段选择-
                    size-
                    -->
    <tree-table-form ref="tableForm" v-if="dialogData.type === 'dialog_tree_table'" style="height: 100%;" :dialog-data="dialogData" :form="form" :close-dialog="closeDialog" :save-data="saveData" :apply-data="applyData" />

    <standard-form v-else :dialog-data="dialogData" :form="form" :close-dialog="closeDialog" :save-data="saveData"/>
  </el-form>
</template>

<script>
import ZyTransfer from "../transfer/ZyTransfer";
import {Message} from "element-ui"
import * as axios from "axios";
import TreeTableForm from "./CommonDialog/TreeTableForm";
import StandardForm from "./CommonDialog/StandardForm";
import DateUtils from "../../../utils/DateUtils";
export default {
  name: "CommonDialog",
  components: {StandardForm, TreeTableForm, ZyTransfer},
  props: ["dialogData", "formData"],
  data() {
    let that = this;
    let validateName = (rule, value, callback) => {
      if(that.formData && that.formData[rule.field] === value) {
        callback();
      }else {
        if(that.nameValMethod) {
          value = value.replace(/^\s*|\s*$/g, "");
          that.nameValMethod({name: value}).then(res => {
            let isNameExist = '';
            if (res.code === 200) isNameExist = '';
            else isNameExist = res.data;
            if (isNameExist !== '') {
              callback(new Error('名称已存在！'));
            }else if(value.length > 24) {
              this.form[rule.field] = this.form[rule.field].substring(0, 24);
              callback(new Error('名称长度应小于24'));
            } else {
              callback();
            }
          })
        }else {
          if(that.form[rule.field] && that.form[rule.field].length > 24) {
            that.form[rule.field] = that.form[rule.field].substring(0, 24);
            callback(new Error('名称长度应小于24'));
          } else {
            callback();
          }
        }
      }
    };
    let validateCode = (rule, value, callback) => {
      if(that.formData && (that.formData[rule.field] + '' === value || that.formData[rule.field] + '' === value + '')) {
        callback();
      }else {
        if(that.form[rule.field] > 999999999999) {
          that.form[rule.field] = Math.floor(that.form[rule.field] / 10);
          callback(new Error('编号长度应小于12'));
        }else {
          if(that.codeValMethod) {
            that.codeValMethod({code: value}).then(res => {
              let isCodeExist = 0;
              if (res.code === 200) isCodeExist = 0;
              else isCodeExist = res.data;
              if (isCodeExist !== 0) {
                callback(new Error('编号已存在!'));
              } else {
                callback();
              }
            })
          }
        }
      }
    };
    let validateAccount = (rule, value, callback) => {
      if(that.formData && (that.formData[rule.field] === value || that.formData[rule.field] === value + '')) {
        callback();
      }else {
        if(that.accountValMethod) {
          that.accountValMethod({account: that.form[rule.field]}).then(res => {
            let isAccountExist = 0;
            if(res.code === 200) isAccountExist = 0;
            else isAccountExist = res.data;
            if(isAccountExist !== 0) {
              callback(new Error('账号已存在!'));
            } else {
              callback();
            }
          })
        }
      }
    };
    let validateIdCard = (rule, value, callback) => {
      const idReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if(value && value.length > 0 && !idReg.test(value)) {
        callback(new Error('15/18位数字，最后一位为数字或X'));
      }else {
        callback();
      }
    };
    return {
      form: {},
      validateNameObj: {validator: validateName},
      validateCodeObj: {validator: validateCode},
      validateAccountObj: {validator: validateAccount},
      validateIdCardObj: {validator: validateIdCard},
      nameValMethod: null,
      codeValMethod: null,
      accountValMethod: null,
      param: [],
      dialogRules: []
    }
  },
  created() {
    this.initData()
  },
  beforeDestroy() {
    this.form = null
  },
  destroyed () {
    this.form = null
  },
  methods: {
    initData() {
      console.log(this.formData);
      if(this.formData) {
        this.form = JSON.parse(JSON.stringify(this.formData));
      }

      if(this.dialogData.items) {
        this.dialogData.items.forEach((item) => {
          if((this.formData && item.type === '') ||
            (this.formData && !this.formData.hasOwnProperty(item.prop) && item.prop !== '') ||
            (!this.formData && item.prop !== '')) {
            this.$set(this.form, item.prop, (item.hasOwnProperty('value') ? item.value : ''));
          }
          if(item.type === 'switch') {
            this.$set(this.form, item.prop, Boolean(this.form[item.prop] === 1));
          }

          if(item.hasOwnProperty('backHandle')) {
            item.backHandle(this.form);
          }

          if((item.type === 'select' || item.type === 'multi_select' || item.type === 'radio' || item.type === 'check' || item.type === 'check-button') && typeof item.method === 'function') {
            if(item.param) {
              item.method(this.form).then(res => {
                if(item.hasOwnProperty('staticOptions')) item.options = item.staticOptions.concat(res.data);
                else item.options = res.data;
              })
            }else {
              item.method().then(res => {
                if(item.hasOwnProperty('staticOptions')) item.options = item.staticOptions.concat(res.data);
                else if(item.hasOwnProperty('extraProps')) {
                  let selOption = {};
                  this.$set(selOption, item.props.value, this.form[item.extraProps.value]);
                  this.$set(selOption, item.props.label, this.form[item.extraProps.label]);
                  item.options = [selOption].concat(res.data);
                }else item.options = res.data;
              })
            }
          }else if (item.type === 'table') {
            let param = this.formData;
            item.method(param).then(res => {
              res.data.forEach((tableItem) => {
                tableItem.status = 1;
              });
              item.tableData = res.data;
              this.form = {};
              this.$set(this.form, 'id', this.formData.id);
              this.$set(this.form, 'task_type', this.formData.task_type);
              this.$set(this.form, 'devDetail', item.tableData);
            })
          }
        })
      }

      if(this.dialogData.rules) {
        this.addValidator();
      }
    },
    addValidator() {
      let validators = this.dialogData.ruleValidator;
      this.dialogRules = JSON.parse(JSON.stringify(this.dialogData.rules));
      if(validators && validators.length > 0) {
        validators.forEach((rv) => {
          if(rv.type === 'name') {
            if(this.dialogRules[rv.name]) {
              this.dialogRules[rv.name].push(this.validateNameObj);
              this.nameValMethod = rv.method;
            }
          }else if(rv.type === 'code') {
            if(this.dialogRules[rv.name]) {
              this.dialogRules[rv.name].push(this.validateCodeObj);
              this.codeValMethod = rv.method;
            }
          }else if(rv.type === 'account') {
            if(this.dialogRules[rv.name]) {
              this.dialogRules[rv.name].push(this.validateAccountObj);
              this.accountValMethod = rv.method;
            }
          }else if(rv.type === 'id') {
            if(this.dialogRules[rv.name]) {
              this.dialogRules[rv.name].push(this.validateIdCardObj);
            }
          }
        });
      }
    },
    closeDialog() {
      this.$emit('closeDialog', this.form);
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if(this.dialogData.excelModel) {
            this.param = [];
            this.dialogData.items.forEach((item) => {
              if(item.prop !== '') this.param.push(this.form[item.prop]);
            });
            let paramStr = '/api/service-energy/' + this.dialogData.excelModel + '/exportExcelModel?searchData=' + this.param.join('_');
            paramStr += '_' + sessionStorage.getItem('token');
            window.open(axios.defaults.baseURL + paramStr);
            this.$emit('closeDialog');
          }else if(this.dialogData.type === 'passwordConfirm') {
            this.dialogData.confirmMethod(this.form);
          }else {
            if(this.dialogData.type === 'dialog_transfer') {
              if(this.dialogData.confirmMethodBody) this.form[this.dialogData.confirmProp] = this.dialogData.transfer.transValue;
              else this.form[this.dialogData.confirmProp] = this.dialogData.transfer.transValue.toString();
              if(typeof this.dialogData.confirmMethod !== "function") {
                this.$emit('closeDialog');
                if(this.form.addList.length > 0) {
                  this.dialogData.confirmMethod[0](this.form.addReqParam).then(res => {
                    if(res.data.code === 200) Message.success(res.data.message);
                    this.$emit('：query');
                  })
                }
                if(this.form.delList.length > 0) {
                  this.dialogData.confirmMethod[1](this.form.delReqParam).then(res => {
                    if(res.data.code === 200) Message.success(res.data.message);
                    this.$emit('closeQuery');
                  })
                }
                return;
              }
            } else if (this.dialogData.type === 'dialog_price') {
              let tipST = [];
              let tipET = [];
              for(let i = 0; i < this.form.tipTime.length; i++) {
                tipST.push(DateUtils.dateFormat("HH:MM", this.form.tipTime[i][0]));
                tipET.push(DateUtils.dateFormat("HH:MM", this.form.tipTime[i][1]));
              }
              this.$set(this.form, 'tipStartTime', tipST);
              this.$set(this.form, 'tipEndTime', tipET);
              let topST = [];
              let topET = [];
              for(let i = 0; i < this.form.topTime.length; i++) {
                topST.push(DateUtils.dateFormat("HH:MM", this.form.topTime[i][0]));
                topET.push(DateUtils.dateFormat("HH:MM", this.form.topTime[i][1]));
              }
              this.$set(this.form, 'topStartTime', topST);
              this.$set(this.form, 'topEndTime', topET);
              let normST = [];
              let normET = [];
              for(let i = 0; i < this.form.normTime.length; i++) {
                normST.push(DateUtils.dateFormat("HH:MM", this.form.normTime[i][0]));
                normET.push(DateUtils.dateFormat("HH:MM", this.form.normTime[i][1]));
              }
              this.$set(this.form, 'normStartTime', normST);
              this.$set(this.form, 'normEndTime', normET);
              let botST = [];
              let botET = [];
              for(let i = 0; i < this.form.botTime.length; i++) {
                botST.push(DateUtils.dateFormat("HH:MM", this.form.botTime[i][0]));
                botET.push(DateUtils.dateFormat("HH:MM", this.form.botTime[i][1]));
              }
              this.$set(this.form, 'botStartTime', botST);
              this.$set(this.form, 'botEndTime', botET);
            }
            if(this.form.ERC_1) {
              this.setErcState();
            }

            if(typeof this.dialogData.confirmLocal === 'function') {
              this.dialogData.confirmLocal(this.form);
              return;
            }
            // 无论成功与否，先关闭弹窗
            this.$emit('closeDialog');
            // 日期格式和boolean处理
            Object.keys(this.form).forEach((formKey) => {
              if(this.form[formKey] !== null) {
                if (typeof this.form[formKey] === 'string') this.form[formKey] = this.form[formKey].replace(/^\s*|\s*$/g, "");
                if (this.form[formKey].Format) this.form[formKey] = this.form[formKey].Format('yyyy-MM-dd');
                if (typeof this.form[formKey] === "boolean") this.form[formKey] = this.form[formKey] ? 1 : 0;
              }
            })
            // 带照片弹窗提交特殊处理
            if(this.form.hasOwnProperty('file')) {
              let formDataForImage = new FormData();
              formDataForImage.set('file', this.form.file);
              Object.keys(this.form).forEach((formKey) => {
                formDataForImage.set(formKey, this.form[formKey]);
              });

              this.dialogData.confirmMethod(formDataForImage).then(res => {
                if(res.message && res.code === 200) Message.success(res.message);
                this.$emit('closeQuery');
              });
              return;
            }
            // 门区特殊处理
            if(this.dialogData.listFlag) {
              let flag = this.dialogData.listFlag.flag;
              let param = [];
              for (let i = 0; i < this.form[flag]; i++) {
                let doorData = {dev_id: this.form.id};
                this.dialogData.listFlag.props.forEach(propName => {
                  doorData[propName] = this.form[propName + '_' + (i + 1)];
                })
                param.push(doorData);
              }
              this.dialogData.confirmMethod(param).then(res => {
                if(res.message && res.code === 200) Message.success(res.message);
                this.$emit('closeQuery');
              })
              return;
            }
            if(this.dialogData.table && this.dialogData.table.add) {
              if(this.dialogData.table.selectShow === true) {
                this.dialogData.table.arr = []
                for(let i = 0; i < this.dialogData.table.showData.length; i++) {
                  this.dialogData.table.arr.push(this.dialogData.table.showData[i].assets_id)
                }
                this.$set(this.form, 'infoList', this.dialogData.table.arr)
              } else {
                for(let i = 0; i < this.dialogData.table.showData.length; i++) {
                  this.dialogData.table.arr.push(this.dialogData.table.showData[i].id)
                }
                this.$set(this.form, 'infoList', this.dialogData.table.arr)
              }
            }
            for(let i = 0; i < this.form.length; i++) {
              this.$set(this.form[i], 'CHARGEMETHOD', this.form.CHARGEMETHOD);
              this.$set(this.form[i], 'CHARGEMONEY', this.form.CHARGEMONEY);
              this.$set(this.form[i], 'REMARK', this.form.REMARK);
            }
            this.dialogData.confirmMethod(this.form).then(res => {
              if(res.message && res.code === 200) Message.success(res.message);
              if(this.dialogData.title === '高级搜索') {
                this.$emit('closeQuery', res.data.rows, this.form);
              } else {
                this.$emit('closeQuery');
              }
            })
          }
        }
      })
    },
    applyData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$refs.tableForm.apply();
        }
      });
    },
    setErcState() {
      let arr = []
      for(let i = 1; i < 17; i++) {
        arr.push(this.form['ERC_' + i])
      }
      this.$set(this.form, 'erc1_16', arr.toString());
      arr = []
      for(let i = 17; i < 33; i++) {
        arr.push(this.form['ERC_' + i])
      }
      this.$set(this.form, 'erc17_32', arr.toString());
      arr = []
      for(let i = 33; i < 49; i++) {
        arr.push(this.form['ERC_' + i])
      }
      this.$set(this.form, 'erc33_48', arr.toString());
      arr = []
      for(let i = 49; i < 65; i++) {
        arr.push(this.form['ERC_' + i])
      }
      this.$set(this.form, 'erc49_64', arr.toString());
      arr = []
      for(let i = 1; i < 9; i++) {
        if(this.form['STATUS_IN_' + i] === '未接入') this.form['STATUS_IN_' + i] = 0;
        else this.form['STATUS_IN_' + i] = 1;
        arr.push(this.form['STATUS_IN_' + i])
      }
      this.$set(this.form, 'stat_input', arr.toString());
      arr = []
      for(let i = 1; i < 9; i++) {
        if(this.form['STATUS_PROP_' + i] === '常闭触点') this.form['STATUS_PROP_' + i] = 0;
        else this.form['STATUS_PROP_' + i] = 1;
        arr.push(this.form['STATUS_PROP_' + i])
      }
      this.$set(this.form, 'stat_prop', arr.toString());
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  watch: {
    formData: function () {
      this.initData();
    }
  }
}
</script>

<style>
  .common-dialog-form .el-form-item__label {
    line-height: 30px;
    padding: 0;
  }
  .common-dialog-form>.el-form-item {
    margin-bottom: 10px;
  }
</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/dialog/CommonDialog.vue